import { NgModule } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastConfig } from './toast-types';
import { I18nModule } from '../i18n/i18n.module';

/**
 * Generic Toast Module
 * Provides toast notification functionality using ngx-toastr
 */
@NgModule({
  imports: [
    I18nModule
  ],
  providers: [
    {
      provide: ToastConfig,
      useValue: {
        showClose: true,
        timeout: 5000,
      }
    },
    ToastService
  ]
})
export class ToastModule {
  static forRoot() {
    return {
      ngModule: ToastModule,
      providers: [
        {
          provide: ToastConfig,
          useValue: {
            showClose: true,
            timeout: 5000,
          }
        },
        ToastService
      ]
    };
  }

  static forChild() {
    return {
      ngModule: ToastModule,
      providers: []
    };
  }
}
